import React from 'react';
import { TippyBase } from '~components/tippy';
import {
  DietaryPreferenceOptions,
  GenderPreferenceOptions,
  PetPreferenceOptions,
  SelectBedDietaryPreferenceOption,
  SelectBedPetPreferenceOption,
  SelectBedSmokingPreferenceOption,
  SmokingPreferenceOptions,
} from '~graphql/__generated__/globalTypes';
import { useTranslation } from '~i18n';
import {
  RulesCoEd,
  RulesDisableYes,
  RulesFemale,
  RulesMale,
  RulesPetNo,
  RulesPetYes,
  RulesSmokingNo,
  RulesSmokingYes,
  RulesVegetarian,
} from '~svg-components';

interface ITippyBookingRulesProps {
  ruleGender: GenderPreferenceOptions | null | undefined;
  ruleSmoking: SelectBedSmokingPreferenceOption | SmokingPreferenceOptions | null | undefined;
  rulePet: SelectBedPetPreferenceOption | PetPreferenceOptions | null | undefined;
  ruleDietart: SelectBedDietaryPreferenceOption | DietaryPreferenceOptions | null | undefined;
  ruleDisablityAccess: boolean;
}

const TippyBookingRules: React.FC<ITippyBookingRulesProps &
  React.HTMLAttributes<HTMLDivElement>> = ({
  style,
  ruleGender,
  ruleSmoking,
  rulePet,
  ruleDietart,
  ruleDisablityAccess,
}) => {
  const { t } = useTranslation(['student_portal']);

  return (
    <div className="tippy-booking-rules" style={{ ...style }}>
      {ruleGender === GenderPreferenceOptions.MALE_ONLY && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.gender_preference.male_only')}
          icon={<RulesMale className="room-detail-node__icon" />}
        />
      )}
      {ruleGender === GenderPreferenceOptions.FEMALE_ONLY && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.gender_preference.female_only')}
          icon={<RulesFemale className="room-detail-node__icon" />}
        />
      )}

      {ruleGender === GenderPreferenceOptions.CO_ED && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.gender_preference.co_ed')}
          icon={<RulesCoEd className="room-detail-node__icon" />}
        />
      )}

      {ruleSmoking === SelectBedSmokingPreferenceOption.PERMITTED && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.smoking_preference.permitted')}
          icon={<RulesSmokingYes className="room-detail-node__icon" />}
        />
      )}

      {ruleSmoking === SelectBedSmokingPreferenceOption.NOT_PERMITTED && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.smoking_preference.not_permitted')}
          icon={<RulesSmokingNo className="room-detail-node__icon" />}
        />
      )}

      {rulePet === SelectBedPetPreferenceOption.PERMITTED && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.pet_preference.permitted')}
          icon={<RulesPetYes className="room-detail-node__icon" />}
        />
      )}

      {rulePet === SelectBedPetPreferenceOption.NOT_PERMITTED && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.pet_preference.not_permitted')}
          icon={<RulesPetNo className="room-detail-node__icon" />}
        />
      )}

      {ruleDietart === SelectBedDietaryPreferenceOption.VEGETARIAN && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.dietary_preference.vegetarian')}
          icon={<RulesVegetarian className="room-detail-node__icon" />}
        />
      )}
      {ruleDisablityAccess && (
        <TippyBase
          className="tippy-booking-rules__item"
          content={t('select_bed.disabled_accessibility.allowed')}
          icon={<RulesDisableYes className="room-detail-node__icon" />}
        />
      )}

      <style jsx>{`
        .tippy-booking-rules {
          display: flex;
          align-items: center;
        }
        :global(.tippy-booking-rules__item) {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
        :global(.room-detail-node__icon) {
          width: 24px;
          height: 24px;
        }
      `}</style>
    </div>
  );
};

export default TippyBookingRules;
